import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { getQueryStringValue } from 'helpers/queryString';

import Loading from 'components/LoadingOverlay';
import WebStorage from 'services/WebStorage';

const withAuth = (WrappedComponent) => {
  class AuthWrapper extends Component {
    constructor(props) {
      super(props);
      this.storage = new WebStorage();
    }

    async componentDidMount() {
      const { user } = this.props;
      if (!user.isAuthenticated) {
        const userToken = getQueryStringValue('usertoken');
        let queryString = window.location.search;
        if (userToken) {
          queryString = window.location.search
            .replace(`usertoken=${userToken}`, '')
            .replace('?&', '?')
            .replace('&&', '&');
        }
        await this.storage.set(
          'origin',
          `${window.location.origin}${window.location.pathname}${queryString}`
        );
        await user.signin();
      }
    }

    render() {
      const { user } = this.props;

      return !user.isAuthenticated ? (
        <Loading fullscreen={true} />
      ) : (
        <WrappedComponent locale={user.profile.locale} {...this.props} />
      );
    }
  }

  return inject('user')(observer(AuthWrapper));
};

export default withAuth;



// WEBPACK FOOTER //
// ./src/app/components/AuthWrapper/index.jsx